export const CACHE_DURATION = 3600000; // 1 hour in milliseconds

interface CacheItem<T> {
    data: T;
    timestamp: number;
}

export const setCache = <T>(key: string, data: T): void => {
    try {
        const cacheItem: CacheItem<T> = {
            data,
            timestamp: Date.now(),
        };
        localStorage.setItem(key, JSON.stringify(cacheItem));
    } catch (error) {
        console.warn('Failed to save to localStorage', error);
    }
};

export const getCache = <T>(key: string): T | null => {
    try {
        const item = localStorage.getItem(key);
        if (!item) return null;

        const parsedItem: CacheItem<T> = JSON.parse(item);
        const isExpired = Date.now() - parsedItem.timestamp > CACHE_DURATION;

        if (isExpired) {
            localStorage.removeItem(key);
            return null;
        }

        return parsedItem.data;
    } catch (error) {
        console.warn('Failed to parse from localStorage', error);
        return null;
    }
};

export const clearCache = (key: string): void => {
    localStorage.removeItem(key);
};
